module.exports = __webpack_public_path__ + "img/frame (87).e5120cb1.jpg";